// extracted by mini-css-extract-plugin
export default {"studentNameCell":"StudentNameCell_studentNameCell__Ke1jC","studentNameCellTooltip":"StudentNameCell_studentNameCellTooltip__mEsh6"};